/**
 * Collection page behavior:
 *  - Auto-submit sort dropdown
 *  - Mobile filter drawer open/close
 */
document.addEventListener('change', (e) => {
  const sort = e.target.closest('[data-collection-sort]');
  if (!sort) return;
  sort.form.submit();
});

document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-action="filters-open"]');
  const close = e.target.closest('[data-action="filters-close"]');
  const filters = document.querySelector('[data-collection-filters]');
  if (!filters) return;
  if (open) {
    filters.dataset.open = 'true';
    document.documentElement.style.overflow = 'hidden';
    open.setAttribute('aria-expanded', 'true');
  }
  if (close) {
    filters.dataset.open = 'false';
    document.documentElement.style.overflow = '';
    const toggle = document.querySelector('[data-action="filters-open"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }
});
